import useSWR, { type SWRConfiguration } from 'swr';

import {
  getPaymentsCatalog,
  type GetPaymentsCatalogResponse,
} from '@services/PaymentsService';

export type UseGetPaymentsCatalogParams = {
  swrOptions?: SWRConfiguration<GetPaymentsCatalogResponse, unknown>;
};

export const getPaymentsCatalogQueryKey = 'get-payments-catalog';

export const useGetPaymentsCatalog = ({
  swrOptions,
}: UseGetPaymentsCatalogParams = {}) => {
  const { data, ...swrResponse } = useSWR<GetPaymentsCatalogResponse>(
    getPaymentsCatalogQueryKey,
    () => getPaymentsCatalog(),
    swrOptions,
  );

  return {
    data,
    ...swrResponse,
  };
};
